import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireRole = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-pulse text-slate-500">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // requireRole accepts either a single role or an array. Allows e.g.
  // ["freelancer", "admin"] for routes admins can access in a preview/impersonation
  // mode (the page itself decides what to render).
  if (requireRole) {
    const allowed = Array.isArray(requireRole) ? requireRole : [requireRole];
    if (!allowed.includes(user.role)) {
      const home = user.role === "admin" ? "/admin" : "/dashboard";
      return <Navigate to={home} replace />;
    }
  }

  return children;
}
